import React, { useMemo } from 'react';
import Tabs from '../../../../components/UI/tab/Tabs';
import { Switch, Route, Link } from 'react-router-dom';
import SubHeader from '../../../../_psb/layout/sub-header/SubHeader';
import PublicInquiryList from './PublicInquiryList';
import ViewPublicInquiry from './ViewPublicInquiry';
import PendingPublicInquiryList from './PendingPublicInquiryList';
import VIewPendingPublicInquiry from './ViewPendingInquiry';
import getLangData from '../../../../utils/getLangData';

const PublicInquiry = () => {
  const tabsProps = useMemo(() => ({
    base: '/customer-public-inquiry-artisan',
    items: [
      { title: 'Public Inquiries', page: '/' },
      { title: 'Proposals', page: '/customer/proposal' }
    ]
  }));
  return (
    <>
      <SubHeader title={getLangData().menu.side.customer_public_inquiries}>
        <Switch>
          {' '}
          {/* <Route
            exact
            path={["/customer-public-inquiry-artisan", '/customer-public-inquiry-artisan/customer/proposal']}
            render={() => <Tabs {...tabsProps} />}
          /> */}
          <>
            <Route
              exact
              path={[
                '/customer-public-inquiry-artisan/',
                '/customer-public-inquiry-supplier'
              ]}
              component={() => (
                <Link
                  style={{ marginRight: '15px' }}
                  to='/customer-public-inquiry-artisan/pending'
                  className='btn btn-primary'
                >
                  {getLangData().buttons.pending}
                </Link>
              )}
            />
            <Route
              exact
              path={[
                '/customer-public-inquiry-artisan/pending',
                '/customer-public-inquiry-supplier'
              ]}
              component={() => (
                <Link
                  to='/customer-public-inquiry-artisan/'
                  className='btn btn-primary'
                >
                  {getLangData().buttons.view}
                </Link>
              )}
            />

            <Route
              exact
              path={[
                '/customer-public-inquiry-artisan/',
                '/customer-public-inquiry-supplier'
              ]}
              component={() => (
                <Link
                  to='/customer-public-inquiry-artisan/create'
                  className='btn btn-primary'
                >
                  {getLangData().buttons.add_new}
                </Link>
              )}
            />
          </>
        </Switch>
      </SubHeader>
      <Switch>
        <Route
          exact
          component={PendingPublicInquiryList}
          path='/customer-public-inquiry-artisan/pending'
        />
        <Route
          exact
          component={VIewPendingPublicInquiry}
          path='/customer-public-inquiry-artisan/pending/:id'
        />{' '}
        <Route
          exact
          component={PublicInquiryList}
          path='/customer-public-inquiry-artisan'
        />
        <Route
          exact
          component={ViewPublicInquiry}
          path='/customer-public-inquiry-artisan/:id'
        />
        <Route
          exact
          component={ViewPublicInquiry}
          path='/customer-public-inquiry-artisan/create'
        />
      </Switch>
    </>
  );
};

export default PublicInquiry;
